module.exports = __webpack_public_path__ + "img/classic_shop_thumbnail.e04ddfe7.jpg";